import type { Uploadable } from '@/models/uploadable';

export enum FileType {
  File = '*',
  Image = 'image/*',
  Video = 'video/*',
  Audio = 'audio/*',
}

export const FILE_LIMIT_MAP: Record<FileType, number> = {
  [FileType.Image]: 9,
  [FileType.Video]: 2,
  [FileType.File]: 1,
  [FileType.Audio]: 1,
};

export const FILE_TYPE_MESSAGE_MAP: Record<FileType, string> = {
  [FileType.Image]: 'common.image',
  [FileType.Video]: 'common.video',
  [FileType.File]: 'common.file',
  [FileType.Audio]: 'common.audio',
};

export function getFileType(file: File | Uploadable) {
  const fileType = file.type.split('/')[0] ?? '';

  switch (fileType) {
    case 'image':
      return FileType.Image;
    case 'video':
      return FileType.Video;
    case 'audio':
      return FileType.Audio;
    default:
      return FileType.File;
  }
}
